// extracted by mini-css-extract-plugin
export default {"PortfoliosPage":"PortfoliosPage_PortfoliosPage__8+rm8","toolbarSwitches":"PortfoliosPage_toolbarSwitches__GU4KM"};